
export const EVENT = {
    CHANGE: "change"
}
export default class {
    /**
     * @param {Api} api
     */
    constructor(api) {
        this.api = api
        this.onEvent = null
        this.API_URL = '/api/messages'
    }

    /**
     * set event handler
     * @param {Function} onEvent
     */
    setEventHandler(onEvent) {
        this.onEvent = onEvent
    }

    /**
     * get all messages
     * @returns {<Object>}
     */
    async getMessages(data = {}, page = 1) {
        if (!data) data = {}
        data['page'] = page
        return await this.api.request('GET', this.API_URL, data)
    }

    /**
     * get a message
     * @param {String} id
     * @returns {<Object>}
     */
    async getMessage(id) {
        const url = `${this.API_URL}/${id}`
        return await this.api.request('GET', url, null)
    }

    /**
     * add a new message
     * @param {Object} data 
     */
    async addMessage(data) {
        const newMessage = await this.api.request('POST', this.API_URL, data)
        this._triggerEvent(EVENT.CHANGE)
        return newMessage
    }

    /**
     * update message
     * @param {Object} message
     */
    async updateMessage(message) {
        console.log('message: ', message)
        const url = `${this.API_URL}/${message._id}`
        const updatedMessage = await this.api.request('PUT', url, message)
        console.log('updatedMessage: ', updatedMessage)
        this._triggerEvent(EVENT.CHANGE)
        return updatedMessage
    }

    /**
     * delete a message
     * @param {String} id
     */
    async deleteMessage(id) {
        const url = `${this.API_URL}/${id}`
        await this.api.request('DELETE', url, null)
        this._triggerEvent(EVENT.CHANGE)
    }

    _triggerEvent(name) {
        if (this.onEvent) this.onEvent(name)
    }

    /**
     * get rated tickets
     * @returns {Object}
     */
    async getRatedTickets(data = {}, page = 1) {
        if (!data) data = {}
        data['page'] = page
        const url = '/api/ticket/rated'
        const tickets = await this.api.request('GET', url, data)
        return tickets
    }
}